import { newSendApiRequest } from './service-gateway';
import { useAuthStore } from '../store/auth/store';
import { useCommonStore } from '../store/store';
import { ownerTypeByTokenType } from '../constants/auth';
import { runningApp } from '../constants/app';
import { endpoints, parameters, values } from '../constants/savedLists';

export const addUserId = userId => ({ parameter: parameters.userId, value: `${userId}` });

export const getParam = (name, value) => ({ parameter: name, value });

export const getParams = ({ownerId, userId, tokenType}) => {
    const applicationParam = getParam(parameters.application, runningApp);
    const params = [applicationParam];
    const isLegacyUser = !userId;
    if (isLegacyUser) {
        params.push(getParam(parameters.ownerId, `${ownerId}`));
        params.push(getParam(parameters.ownerType, ownerTypeByTokenType[tokenType]));
        return params;
    }
    return [ ...params, addUserId(userId) ];
};

export const getUserParams = (ownerId) => {
    const tokenType = useAuthStore.getState()?.tokenType;
    const userId = useCommonStore.getState()?.userInfo?.id;
    return getParams({ownerId, userId, tokenType});
};

export const getUserSavedSearches = async (ownerId, module, searchType) => {
    const userParams = getUserParams(ownerId);
    const params = [
        ...userParams,
        getParam(parameters.module, module),
        getParam(parameters.searchType, searchType),
    ];
    return await newSendApiRequest(
        endpoints.savedSearchList,
        params
    );
};

export const getMarketAreaLists = async (ownerId) => await newSendApiRequest(
    endpoints.marketAreaList,
    getUserParams(ownerId)
);

export const getOfficeLists = async (ownerId) => await newSendApiRequest(
    endpoints.officeList,
    getUserParams(ownerId)
);

export const getAgentLists = async (ownerId) => await newSendApiRequest(
    endpoints.agentList,
    getUserParams(ownerId)
);

export const getComparisonSetsByUser = async (userId) => {
    return await newSendApiRequest(
        endpoints.mlsObjectList,
        [
            { parameter: parameters.ownerId, value: `${userId}` },
            { parameter: parameters.ownerType, value: values.userId },
            { parameter: parameters.objectType, value: values.comparisonSet }
        ]
    );
};
